module.exports = __webpack_public_path__ + "static/media/bundt-cake.9c935418.jpg";